<template>
    <div class="fixed inset-0 z-[99999999] flex items-center justify-center bg-black/40 backdrop-blur-sm p-4">
        <div class="bg-white rounded-3xl shadow-2xl w-full max-w-md px-8 py-6 space-y-6 transition-all duration-300">

            <!-- Titre -->
            <h2 class="text-2xl font-semibold text-center text-gray-900 tracking-tight">
                {{ $t('paiement') }}
            </h2>

            <!-- Montant -->
            <div class="text-center space-y-1">
                <p class="text-sm text-gray-500">{{ $t('montanttotal') }}</p>
                <p class="text-4xl font-bold text-gray-900">{{ totalFormatted }} €</p>
            </div>

            <!-- Options de paiement -->
            <div>
                <label class="block text-sm font-medium text-gray-700 mb-2">{{ $t('choisissezunmodedepaiement') }} :</label>
                <div class="flex flex-col gap-3">
                    <button :class="paymentStep === 1 ? activeClass : baseClass" @click="paymentStep = 1">
                        {{ $t('paiementenunefois') }}
                    </button>
                    <button :class="paymentStep === 2 ? activeClass : baseClass" @click="paymentStep = 2">
                        {{ $t("paiementen2fois") }}
                    </button>
                </div>
            </div>

            <!-- Actions -->
            <div class="flex justify-between gap-4 pt-2">
                <button class="w-1/2 py-2 text-gray-600 bg-gray-100 hover:bg-gray-200 rounded-xl transition font-medium"
                    @click="$emit('closeModal')">
                    {{ $t('annuler') }}
                </button>
                <button class="w-1/2 py-2 bg-gray-900 text-white hover:bg-gray-800 rounded-xl transition font-semibold"
                    @click="validerPaiement">
                    {{ $t('valider') }}
                </button>
            </div>

        </div>
    </div>
</template>

<script>
export default {
    props: {
        total: Number,
    },
    data() {
        return {
            paymentStep: 1, // 1 pour paiement en une fois, 2 pour paiement en deux fois
        };
    },
    computed: {
        totalFormatted() {
            return this.total;
        },
        baseClass() {
            return 'w-full px-4 py-3 rounded-xl border border-gray-300 text-gray-700 hover:bg-gray-50 text-sm transition';
        },
        activeClass() {
            return 'w-full px-4 py-3 rounded-xl bg-gray-900 text-white font-medium shadow-md text-sm';
        },
    },
    methods: {
        validerPaiement() {
            localStorage.removeItem("payment_method");
            if (this.paymentStep === 2) {
                localStorage.setItem("payment_method", "klarna");
            } 
            this.$emit('ShowPayementTap');

        },
    },
};
</script>

<style scoped>
/* Ajout d’un léger effet d’animation */
button {
    transition: all 0.2s ease-in-out;
}
</style>
